/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorBoardOutcome from './tumor-board-outcome';
import TumorBoardOutcomeDetail from './tumor-board-outcome-detail';
import TumorBoardOutcomeUpdate from './tumor-board-outcome-update';
import TumorBoardOutcomeDeleteDialog from './tumor-board-outcome-delete-dialog';

const TumorBoardOutcomeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorBoardOutcome />} />
    <Route path="new" element={<TumorBoardOutcomeUpdate />} />
    <Route path=":id">
      <Route index element={<TumorBoardOutcomeDetail />} />
      <Route path="edit" element={<TumorBoardOutcomeUpdate />} />
      <Route path="delete" element={<TumorBoardOutcomeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorBoardOutcomeRoutes;
